<template>
  <v-container class="fill-height background-color: primary">
    <v-row no-gutters align="center" justify="center" class="white--text">
      <v-col cols="12" sm="12" md="6" xl="4">
        <span
          class="font-weight-light"
          :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
        >WELCOME TO</span>

        <br />

        <span
          :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
          class="font-weight-black"
        >TRADING IF</span>
        <p />

        <v-card color="transparent" flat>
          <v-card-subtitle>TRADING now, IF meets my strategy</v-card-subtitle>
          <v-card-text>
            <v-sheet height="2" color="#DAD9D9" elevation="1" tile></v-sheet>
            <v-sheet height="100" elevation="-1" color="#2B3D50" tile class="align-self-center">
              <div class="pa-5">
                <vue-typer class="subtitle" :type-delay="200" :text="typer.texts"></vue-typer>
              </div>
            </v-sheet>
          </v-card-text>
          <v-card-text>
            <v-list color="transparent">
              <v-list-item-group class="text-center white--text">
                <v-list-item @click="$vuetify.goTo('#idea')">
                  <span class="white--text">
                    Set
                    <b class="background-color: light-blue darken-1">ALERT</b>
                    on your favorite platform.
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item @click="$vuetify.goTo('#command')">
                  <span>
                    Set
                    <b class="background-color: light-blue darken-1">COMMANDS</b>
                    for Auto Trading.
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item @click="$vuetify.goTo('#strategy')">
                  <span>
                    Ajust
                    <b class="background-color: light-blue darken-1">STRATEGY</b>
                    for your idea.
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item @click="$vuetify.goTo('#copy')">
                  <span>
                    Send
                    <b class="background-color: light-blue darken-1">COPY</b>
                    to all accounts
                  </span>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined text :to="{'path': '/login'}">
              <v-icon class="mr-3">account_circle</v-icon>Join Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6" xl="4">
        <v-img
          :min-height="'calc(50vh - ' + $vuetify.application.top + 'px)'"
          src="@/assets/bluetheme/Intro.png"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
var VueTyper = require("vue-typer").VueTyper;

export default {
  name: "Intro",
  components: {
    VueTyper
  },
  data() {
    return {
      typer: {
        texts: [
          "{{ EURUSD: sell 2% balance sl@1.222 }}",
          "{{ EURUSD: protect 10% profit }}",
          "{{ EURUSD: close 10% profit }}"
        ]
      }
    };
  }
};
</script>

<style>
.vue-typer {
  font-family: monospace;
}

.vue-typer .custom.char {
  color: #d4d4bd;
}
.vue-typer .custom.char.selected {
  background-color: #44475a;
}

.vue-typer .custom.caret {
  width: 5px;
  background-color: white;
}
</style>